import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-bg-card border-y border-border-color" data-id="element-52">
      <div className="container max-w-3xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-bg-primary border-2 border-border-color rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-54">
          <div className="flex-shrink-0" data-id="element-55">
            <ShieldCheck className="w-24 h-24 text-cta-primary" data-id="element-56" />
          </div>

          <div data-id="element-57">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-text-primary mb-4" data-id="element-58">
              Garantía 7 días — Cero riesgo
            </h2>
            <p className="text-lg text-text-secondary leading-relaxed" data-id="element-59">
              "Si lo compras, lo revisas y sentís que no es para ti, pedís
              reembolso dentro de 7 días y listo. Sin preguntas incómodas."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}